import React from 'react'

const Subtitle = ({title}) => {

    return(

        <div className='lg:border-b-4 md:border-b-2 border-b-2 py-2 w-8/12 mx-auto shadow-lg' style={{borderColor: '#0eaf58'}}>
            <h1 className="text-center w-full text-xl lg:text-4xl md:text-xl sm:text-lg font-semibold" style={{color: '#0eaf58'}}>
                {title}
            </h1>
        </div>

    );
}

export default Subtitle;